export type Dimensions = Readonly<{ width: number; height: number }>;

export function calculateOutputDimensions(
  width: number,
  height: number,
  requestedLongestEdge: number | 'original',
): Dimensions {
  if (!Number.isInteger(width) || !Number.isInteger(height) || width <= 0 || height <= 0) {
    throw new RangeError('Image dimensions must be positive integers.');
  }

  if (requestedLongestEdge === 'original') {
    return { width, height };
  }

  if (!Number.isFinite(requestedLongestEdge) || requestedLongestEdge <= 0) {
    throw new RangeError('The requested longest edge must be positive.');
  }

  const longestEdge = Math.max(width, height);
  if (longestEdge <= requestedLongestEdge) {
    return { width, height };
  }

  const scale = requestedLongestEdge / longestEdge;
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
}
